module.exports = __webpack_public_path__ + "img/pikat.2477e6a5.png";